"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9802,1019,9521],{

/***/ 29521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "database": function() { return /* binding */ database; }
/* harmony export */ });
/* harmony import */ var firebase_database__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51019);
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64097);
/* provided dependency */ var process = __webpack_require__(34155);


var app = (0,_app__WEBPACK_IMPORTED_MODULE_1__/* .getApp */ .Mq)();
var database = (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.getDatabase)(app);
var connectedEmulator = false;
if (!connectedEmulator && process.env.NEXT_PUBLIC_EMULATOR_MODE === "true") {
    (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.connectDatabaseEmulator)(database, "localhost", 9000);
    connectedEmulator = true;
}



/***/ }),

/***/ 31113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ConnectionSentinel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30137);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71484);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var firebase_database__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51019);
/* harmony import */ var _config_firebase_client_database__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29521);
/* eslint-disable @blumintinc/blumint/require-dynamic-firebase-imports */ 




var RTDB_CONNECTION_PATH = ".info/connected";
var ConnectionSentinel = /*#__PURE__*/ function() {
    "use strict";
    function ConnectionSentinel(settings) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__._)(this, ConnectionSentinel);
        this.settings = settings;
        this.connectedRef = (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.ref)(settings.rtDb || _config_firebase_client_database__WEBPACK_IMPORTED_MODULE_1__.database, RTDB_CONNECTION_PATH);
    }
    var _proto = ConnectionSentinel.prototype;
    _proto.connect = function connect() {
        var _this = this;
        this.unsubscribe = (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.onValue)(this.connectedRef, function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__._)(function(snapshot) {
                var _settings, ref;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!snapshot.val()) return [
                                3,
                                5
                            ];
                            if (!_this.settings.onDisconnect) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                _this.settings.onDisconnect()
                            ];
                        case 1:
                            _this.disconnectData = _state.sent();
                            return [
                                4,
                                (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.onDisconnect)(_this.settings.realtimeRef).update(_this.disconnectData)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                (ref = (_settings = _this.settings).onConnect) === null || ref === void 0 ? void 0 : ref.call(_settings)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(snapshot) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    _proto.disconnect = function disconnect() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__._)(function() {
            var _obj, ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (ref = (_obj = _this).unsubscribe) === null || ref === void 0 ? void 0 : ref.call(_obj);
                        if (!_this.disconnectData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,firebase_database__WEBPACK_IMPORTED_MODULE_0__.update)(_this.settings.realtimeRef, _this.disconnectData)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return ConnectionSentinel;
}();


/***/ }),

/***/ 29802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SessionManager": function() { return /* binding */ SessionManager; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_async_to_generator.js
var _async_to_generator = __webpack_require__(30137);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_class_call_check.js
var _class_call_check = __webpack_require__(71484);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/esm/_create_class.js
var _create_class = __webpack_require__(29033);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/typescript-memoize/dist/es2015/memoize-decorator.js
var memoize_decorator = __webpack_require__(43292);
// EXTERNAL MODULE: ./node_modules/firebase/database/dist/esm/index.esm.js
var index_esm = __webpack_require__(51019);
// EXTERNAL MODULE: ./src/util/realtime/ConnectionSentinel.ts
var ConnectionSentinel = __webpack_require__(31113);
;// CONCATENATED MODULE: ./functions/src/realtime/session/config.ts
/**
 * Why does this exist?
 * Just in case, for whatever reason, the frontend
 * fails to take a user offline when they sign out,
 * we'll automatically take them offline after 15 minutes.
 */ var POLLING_INTERVAL = 1000 * 60 * 15;
var POLLING_BUFFER = (/* unused pure expression or super */ null && (1000 * 30));

;// CONCATENATED MODULE: ./functions/src/types/realtimeDb/Session/path.ts
var SESSION_MAP_PATH = "/session/{userId}";
var toSessionMapPath = function(userId) {
    return SESSION_MAP_PATH.replace("{userId}", userId);
};
var SESSION_PATH = "".concat(SESSION_MAP_PATH, "/{sessionId}");
var toSessionPath = function(userId, sessionId) {
    return SESSION_PATH.replace("{userId}", userId).replace("{sessionId}", sessionId);
};

// EXTERNAL MODULE: ./src/config/firebase-client/database.ts
var database = __webpack_require__(29521);
;// CONCATENATED MODULE: ./src/util/session/SessionManager.dynamic.ts







// eslint-disable-next-line @blumintinc/blumint/require-dynamic-firebase-imports




// eslint-disable-next-line @blumintinc/blumint/require-dynamic-firebase-imports

var SessionManager = /*#__PURE__*/ function() {
    "use strict";
    function SessionManager(settings) {
        (0,_class_call_check._)(this, SessionManager);
        this.settings = settings;
    }
    var _proto = SessionManager.prototype;
    _proto.connect = function connect() {
        this.sentinel.connect();
        this.startPolling();
    };
    _proto.updateStatus = function updateStatus(status) {
        var _this = this;
        return (0,_async_to_generator._)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,index_esm.update)(_this.sessionRef, {
                                status: status,
                                lastChanged: (0,index_esm.serverTimestamp)()
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.startPolling = function startPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
        var _this = this;
        // eslint-disable-next-line no-restricted-globals
        this.pollingInterval = setInterval(/*#__PURE__*/ (0,_async_to_generator._)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.updateLastChanged()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), POLLING_INTERVAL);
    };
    _proto.updateLastChanged = function updateLastChanged() {
        var _this = this;
        return (0,_async_to_generator._)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,index_esm.update)(_this.sessionRef, {
                                lastChanged: (0,index_esm.serverTimestamp)()
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.disconnect = function disconnect() {
        var _this = this;
        return (0,_async_to_generator._)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this.pollingInterval) {
                            clearInterval(_this.pollingInterval);
                            _this.pollingInterval = undefined;
                        }
                        return [
                            4,
                            _this.sentinel.disconnect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    (0,_create_class._)(SessionManager, [
        {
            key: "sentinel",
            get: function get() {
                var _this = this;
                return new ConnectionSentinel/* ConnectionSentinel */.v({
                    realtimeRef: this.sessionRef,
                    onConnect: function() {
                        return _this.updateStatus("online");
                    },
                    onDisconnect: function() {
                        return {
                            status: "offline",
                            lastChanged: (0,index_esm.serverTimestamp)()
                        };
                    }
                });
            }
        },
        {
            key: "sessionRef",
            get: function get() {
                return (0,index_esm.ref)(database.database, toSessionPath(this.userId, this.sessionId));
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.settings.userId;
            }
        },
        {
            key: "sessionId",
            get: function get() {
                return this.settings.sessionId;
            }
        }
    ]);
    return SessionManager;
}();
(0,tslib_es6.__decorate)([
    (0,memoize_decorator/* Memoize */.PW)(),
    (0,tslib_es6.__metadata)("design:type", Function),
    (0,tslib_es6.__metadata)("design:paramtypes", [])
], SessionManager.prototype, "sentinel", null);
(0,tslib_es6.__decorate)([
    (0,memoize_decorator/* Memoize */.PW)(),
    (0,tslib_es6.__metadata)("design:type", Function),
    (0,tslib_es6.__metadata)("design:paramtypes", [])
], SessionManager.prototype, "sessionRef", null);
(0,tslib_es6.__decorate)([
    (0,memoize_decorator/* Memoize */.PW)(),
    (0,tslib_es6.__metadata)("design:type", Function),
    (0,tslib_es6.__metadata)("design:paramtypes", [
        String
    ])
], SessionManager.prototype, "updateStatus", null);
(0,tslib_es6.__decorate)([
    (0,memoize_decorator/* Memoize */.PW)(),
    (0,tslib_es6.__metadata)("design:type", Function),
    (0,tslib_es6.__metadata)("design:paramtypes", [])
], SessionManager.prototype, "updateLastChanged", null);
(0,tslib_es6.__decorate)([
    (0,memoize_decorator/* Memoize */.PW)(),
    (0,tslib_es6.__metadata)("design:type", Function),
    (0,tslib_es6.__metadata)("design:paramtypes", [])
], SessionManager.prototype, "disconnect", null);


/***/ }),

/***/ 51019:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DataSnapshot": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Vf; },
/* harmony export */   "Database": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.vo; },
/* harmony export */   "OnDisconnect": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.vA; },
/* harmony export */   "QueryConstraint": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.O$; },
/* harmony export */   "TransactionResult": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.rW; },
/* harmony export */   "_QueryImpl": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.JH; },
/* harmony export */   "_QueryParams": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.G$; },
/* harmony export */   "_ReferenceImpl": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.tn; },
/* harmony export */   "_TEST_ACCESS_forceRestClient": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.ov; },
/* harmony export */   "_TEST_ACCESS_hijackHash": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.a_; },
/* harmony export */   "_initStandalone": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.ly; },
/* harmony export */   "_repoManagerDatabaseFromApp": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.wj; },
/* harmony export */   "_setSDKVersion": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.AM; },
/* harmony export */   "_validatePathString": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.FQ; },
/* harmony export */   "_validateWritablePath": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.mI; },
/* harmony export */   "child": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.iU; },
/* harmony export */   "connectDatabaseEmulator": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.dH; },
/* harmony export */   "enableLogging": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.U7; },
/* harmony export */   "endAt": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Wu; },
/* harmony export */   "endBefore": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Lx; },
/* harmony export */   "equalTo": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.EW; },
/* harmony export */   "forceLongPolling": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Ot; },
/* harmony export */   "forceWebSockets": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.TD; },
/* harmony export */   "get": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.U2; },
/* harmony export */   "getDatabase": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.N8; },
/* harmony export */   "goOffline": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Sb; },
/* harmony export */   "goOnline": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.$o; },
/* harmony export */   "increment": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.nP; },
/* harmony export */   "limitToFirst": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Kk; },
/* harmony export */   "limitToLast": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.vh; },
/* harmony export */   "off": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.S1; },
/* harmony export */   "onChildAdded": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.yv; },
/* harmony export */   "onChildChanged": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Jr; },
/* harmony export */   "onChildMoved": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Vt; },
/* harmony export */   "onChildRemoved": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.MQ; },
/* harmony export */   "onDisconnect": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.ae; },
/* harmony export */   "onValue": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.jM; },
/* harmony export */   "orderByChild": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.g2; },
/* harmony export */   "orderByKey": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.R; },
/* harmony export */   "orderByPriority": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.HE; },
/* harmony export */   "orderByValue": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Bd; },
/* harmony export */   "push": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.VF; },
/* harmony export */   "query": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.IO; },
/* harmony export */   "ref": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.iH; },
/* harmony export */   "refFromURL": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.qT; },
/* harmony export */   "remove": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Od; },
/* harmony export */   "runTransaction": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.i3; },
/* harmony export */   "serverTimestamp": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Bt; },
/* harmony export */   "set": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.t8; },
/* harmony export */   "setPriority": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Sl; },
/* harmony export */   "setWithPriority": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.cy; },
/* harmony export */   "startAfter": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.TQ; },
/* harmony export */   "startAt": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.e0; },
/* harmony export */   "update": function() { return /* reexport safe */ _firebase_database__WEBPACK_IMPORTED_MODULE_0__.Vx; }
/* harmony export */ });
/* harmony import */ var _firebase_database__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15276);

//# sourceMappingURL=index.esm.js.map


/***/ })

}]);